import React from 'react'
import useStore from '../../../../context/StoreContext'
import SelectField from '../../../atoms/fields/select'
import styled from 'styled-components'
import { useIsMobile } from '../../../../hooks/useIsMobile'

const currencyOptions = (isMobile) => [
  {
    label: isMobile ? '£' : 'GBP',
    value: 'GB',
    symbol: '£',
    disabled: false,
  },
  {
    label: isMobile ? '€' : 'EUR',
    value: 'INT',
    sybmol: '€',
    disabled: false,
  },
  {
    label: isMobile ? '$' : 'USD',
    value: 'US',
    symbol: '$',
    disabled: false,
  },
]

const Container = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 4px;

  & > div {
    height: 100%;
    align-items: center;
    justify-content: center;

    .input-wrapper {
      border: solid 1px #e1e3db;
    }
  }

  label,
  .select-padding-top {
    display: none;
  }

  select {
    padding: 8px 32px 8px 16px;
    font-size: 16px;
  }
`

function CurrencySwitcher() {
  const { currentMarket, setCurrentMarket } = useStore()
  const isMobile = useIsMobile()

  const onChange = (e) => {
    setCurrentMarket(e.target.value)

    localStorage.setItem('currentMarket', e.target.value)
  }

  return (
    <Container>
      <SelectField
        labelText="Currency Switcher"
        labelFor="currency"
        placeholderText=""
        fieldId="currency"
        fieldName="currency"
        value={currentMarket}
        options={currencyOptions(isMobile)}
        onChange={onChange}
      />
    </Container>
  )
}

export default CurrencySwitcher
